import React from "react";

const Question = ({ question, answers, selectAnswer }) => {
  return (
    <div className="bg-white rounded-3 border shadow-sm p-5">
      <h5>{question.text}</h5>
      <div className="row mt-4">
        <div className="col-12 col-lg-6 mb-3">
          <input
            type="radio"
            className="btn-check"
            name="answer"
            id="optionA"
            autoComplete="off"
            onChange={() => selectAnswer(question.id, "a")}
            checked={answers[question.id] === "a"}
          />
          <label
            className="btn btn-outline-dark w-100 text-start"
            htmlFor="optionA"
          >
            <span className="fw-bold">A.</span> {question.a}
          </label>
        </div>
        <div className="col-12 col-lg-6 mb-3">
          <input
            type="radio"
            className="btn-check"
            name="answer"
            id="optionB"
            autoComplete="off"
            onChange={() => selectAnswer(question.id, "b")}
            checked={answers[question.id] === "b"}
          />
          <label
            className="btn btn-outline-dark w-100 text-start"
            htmlFor="optionB"
          >
            <span className="fw-bold">B.</span> {question.b}
          </label>
        </div>
        <div className="col-12 col-lg-6 mb-3">
          <input
            type="radio"
            className="btn-check"
            name="answer"
            id="optionC"
            autoComplete="off"
            onChange={() => selectAnswer(question.id, "c")}
            checked={answers[question.id] === "c"}
          />
          <label
            className="btn btn-outline-dark w-100 text-start"
            htmlFor="optionC"
          >
            <span className="fw-bold">C.</span> {question.c}
          </label>
        </div>
        <div className="col-12 col-lg-6 mb-3">
          <input
            type="radio"
            className="btn-check"
            name="answer"
            id="optionD"
            autoComplete="off"
            onChange={() => selectAnswer(question.id, "d")}
            checked={answers[question.id] === "d"}
          />
          <label
            className="btn btn-outline-dark w-100 text-start"
            htmlFor="optionD"
          >
            <span className="fw-bold">D.</span> {question.d}
          </label>
        </div>
      </div>
    </div>
  );
};

export default Question;
